<template>
  <v-container>
    <v-btn fab icon @click="$router.go(-1)" >
      <v-icon style="font-weight: bold; font-size: 2.5rem">chevron_left</v-icon>
    </v-btn>
    <v-layout  row wrap>
      <v-progress-linear indeterminate v-if="firstLoading"></v-progress-linear>
        <v-flex lg4 xs12>
          <v-progress-linear v-if="loading && !firstLoading" indeterminate></v-progress-linear>
          <div v-if="!firstLoading" style="margin-right: 2rem">

          <v-card-title ref="fieldsParent" class="headline form-fill-header">
            {{ formName }}
            <DialogPicker v-if="schemas" :init="schema.id" v-on:picked="changeSchema($event)"
                          title="Wybierz schemat" :items="schemas" itemText="name" itemValue="id">
              <template v-slot:activator="{on}"><v-icon v-on="on" color="black" class="schema-edit-icon" dark>edit</v-icon> </template>
            </DialogPicker>
          </v-card-title>
            <div>
              <v-autocomplete
                  style="width:100%" v-if="workers.length > 0"
                  v-model="payload.worker_guid"
                  :items="workers"
                  item-text="name"
                  item-value="guid"
                  label="Pracownik"
                  :filter="filterWorkers"
              >
                <template v-slot:selection="data" >
                  {{ data.item ? data.item.name + " " +  data.item.surname : ''}}
                </template>
                <template v-slot:item="data" >
                  {{ data.item ? data.item.name + " " +  data.item.surname : ''}}
                </template>
              </v-autocomplete>
            </div>

            <v-menu :close-on-content-click="true" :nudge-right="40" full-width lazy min-width="290px"
                    offset-y
                    transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="payload.document_date" label="Data dokumentu" readonly clearable v-on="on"></v-text-field>
              </template>
              <v-date-picker
                  v-model="payload.document_date"
                  locale="pl"
                  :landscape="true">
              </v-date-picker>
            </v-menu>
            <v-checkbox v-model="infinityDate" label="Dokument bez daty ważności"></v-checkbox>
            <v-menu v-if="!infinityDate" :close-on-content-click="true" :nudge-right="40" full-width
                    lazy min-width="290px"
                    offset-y transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="payload.expiration_date" label="Data ważności dokumentu" readonly clearable v-on="on"></v-text-field>
              </template>
              <v-date-picker
                  v-model="payload.expiration_date"
                  locale="pl"
                  :landscape="true">
              </v-date-picker>
            </v-menu>


            <div  v-on:click="fieldClicked($event,field)"  style="margin-top:20px" v-for="field in fields" :key="field.id">
            <component  :ref="`field_${field.order}`" :field="field" :is="getInputComponent(field.type)" :context="Context.createFormContextWithFields(fields)" :value="getValue(field.order)" @setValue="setValue($event, field.order)">
            </component>
          </div>


          <v-card-actions  >
            <v-spacer></v-spacer>
            <v-btn  :disabled="loading || firstLoading" large round class="primary" @click="submit(states.COMPLETED)">{{ $t("base.save") }}</v-btn>
          </v-card-actions>

          </div>
        </v-flex>

        <v-flex lg8 xs12>
<!--          <DocumentImageManager :disable-loading="firstLoading" :schemaId="$route.params.schemaId" :formId="$route.params.formId" v-on:textRecognized="textRecognized($event)"/>-->
          <PDFViewer v-if="document && document.file" :base64="`data:application/pdf;base64,${this.document.file.data}`"></PDFViewer>
        </v-flex>

    </v-layout>

  </v-container>
</template>

<script>
import NewWorker from "@/components/document/worker/NewWorker"
import http from "@/plugins/http"
import PDFViewer from "@/components/pdf/Viewer"
import TextInput from "@/components/form/inputs/Text"
import NumberInput from "@/components/form/inputs/Number"
import DateInput from "@/components/form/inputs/Date"
import TimeInput from "@/components/form/inputs/Time"
import RadioInput from "@/components/form/inputs/Radio"
import TableInput from "@/components/form/inputs/Table"
import MultipleInput from "@/components/form/inputs/Multiple"
import SignatureInput from "@/components/form/inputs/Signature"
import PhotoInput from "@/components/form/inputs/Photo"
import CodeInput from "@/components/form/inputs/Code"
import ArchiveInput from "@/components/form/inputs/Archive"
import RelatedInput from "@/components/form/inputs/Related"
import DependInput from "@/components/form/inputs/SelectDepend"
import CheckboxInput from "@/components/form/inputs/Checkbox"
import fieldType from '@/enums/fieldType'
import Context from '@/plugins/Context'
import Messenger from "@/plugins/Messenger"
import DocumentImageManager from "@/components/document/DocumentImageManager"
import DialogPicker from "@/components/common/DialogPicker"
import DocumentForm from "@/mixins/Document"

export default {
  name: "Edit",
  components: {
    NewWorker,
    DialogPicker,
    PDFViewer,
    TextInput,
    NumberInput,
    DateInput,
    TimeInput,
    RadioInput,
    TableInput,
    MultipleInput,
    SignatureInput,
    PhotoInput,
    CodeInput,
    ArchiveInput,
    RelatedInput,
    CheckboxInput,
    DependInput,
    DocumentImageManager
  },
  mixins: [DocumentForm],
  data() {
    return {
      Context,
    }
  },
  computed:{
    values(){
      return this.relatedValues
    }
  },
  created() {
    this.firstLoading = true

    let schema = http.get('schema/' + this.$route.params.schemaId)
    let form = http.get('form/' + this.$route.params.schemaId + '/' + this.$route.params.formId)
    let document = http.get('document/schema/' + this.$route.params.schemaId + '/form/' + this.$route.params.formId)

    Promise.all([schema, form, document]).then(data => {
      this.schema = data[0].data
      this.fields = data[0].data.fields.filter(field => !fieldType.hidden.includes(field.type))
      this.formName = data[0].data.name
      this.document = data[2].data
      this.payload = data[1].data
      this.payload.schema_id = parseInt(data[0].data.id)
      this.payload.worker_guid = this.document.worker_guid
      this.payload.document_date = this.document.document_date
      this.payload.expiration_date = this.document.expiration_date

      if (this.document.expiration_date != '9999-12-31') {
        this.infinityDate = false
      }

      this.loadActiveWorkers()
      this.loadSchemas()
      this.firstLoading = false
    }).catch(() => {
      this.$router.push({
        name: "not-found"
      })
    })
  },
  methods: {
    submit(state) {
      if(!this.validatePayloadData()){
        return
      }

      this.firstLoading = true
      this.payload.state = state
      this.payload.results = this.payload.results.filter(this.notUpdateField)

      if(this.infinityDate){
        this.payload.expiration_date = '9999-12-31'
      }


      http.put('document/schema/' + this.$route.params.schemaId + '/form/' + this.$route.params.formId, this.payload)
        .then(() => {
          this.firstLoading = false
          this.$store.commit("setSnack", {
            "message": "Dokument został edytowany",
            "color": "success"
          })
        }).catch(() => {
          this.firstLoading = false
          Messenger.emitError("Nie można edytować dokumentu")
        })
    },
    loadActiveWorkers() {
      this.loading = true
      http.get(`/document/workers?active=1`).then(data=>{
        this.workers = data.data
        this.loading = false
      }).catch(()=>Messenger.emitError("Problem z załadowaniem pracowników"))
    },
  },
}
</script>

<style>
.form-fill-header {
  margin: 11px;
}
</style>
